import { useState, useEffect } from "react";
import { fetchQuickSearchResults } from "../services/quick-search.service";
import { useSidebarData } from "./use-sidebar-data.hook";

export const useQuickSearch = () => {
  const [searchList, setSearchList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useSidebarData();

  const getQuickSearch = async (forceRefresh = false) => {
    setIsLoading(true);
    try {
      const data = await fetchQuickSearchResults(forceRefresh);
      setSearchList(data);
    } catch (error) {
      console.error("Failed to fetch quick search results:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getQuickSearch();
  }, []);

  return { searchList, isLoading, getQuickSearch };
};
